import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback } from 'react';
import { Toast } from './Toast';
const ToastContext = createContext(undefined);
export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);
    const showToast = useCallback((type, message, duration = 3000) => {
        const id = Math.random().toString(36).substring(2, 9);
        const newToast = { id, type, message, duration };
        setToasts((prev) => [...prev, newToast]);
        // 自动移除
        setTimeout(() => {
            setToasts((prev) => prev.filter((toast) => toast.id !== id));
        }, duration);
    }, []);
    const success = useCallback((message, duration) => showToast('success', message, duration), [showToast]);
    const error = useCallback((message, duration) => showToast('error', message, duration), [showToast]);
    const info = useCallback((message, duration) => showToast('info', message, duration), [showToast]);
    const warning = useCallback((message, duration) => showToast('warning', message, duration), [showToast]);
    const handleClose = useCallback((id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, []);
    return (_jsxs(ToastContext.Provider, { value: { showToast, success, error, info, warning }, children: [children, _jsx("div", { className: "fixed bottom-4 right-4 z-50 flex flex-col gap-2", children: toasts.map((toast) => (_jsx(Toast, { type: toast.type, message: toast.message, onClose: () => handleClose(toast.id) }, toast.id))) })] }));
}
export function useToastManager() {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToastManager must be used within ToastProvider');
    }
    return context;
}
